import ImagenPerfil from './ImagenPerfil'

/**
 *
 * @param {Object} props - Props que recibe el componente.
 * @param {number} props.id - El id del grupo, serie, subserie o perfil.
 * @param {string} props.className - La clase a aplicar en el div padre.
 * @param {string} props.codigoGrupo - El c�digo del grupo seleccionado.
 * @param {string} props.nombreGrupo - Opcional. Nombre del grupo seleccionado.
 * @param {string} props.codigoSerie - Opcional. El c�digo de la serie seleccionada.
 * @param {string} props.nombreSerie - Opcional. El nombre de la serie seleccionada.
 * @param {string} props.codigoSubserie - Opcional. El c�digo de la subserie seleccionada.
 * @param {string} props.nombreSubserie - Opcional. El nombre de la subserie seleccionada.
 * @param {string} props.codigoPerfil - Opcional. El c�digo del perfil seleccionado.
 * @param {string} props.nombrePerfil - Opcional. El nombre del perfil seleccionado.
 * @param {VoidFunction} props.onClick - Funci�n a llamar al hacer un onClick sobre el elemento
 * @param {string} props.imagen - Opcional. Imagen del grupo, serie o subserie a mostrar
 * @param {string} props.nombreDisplayed - Opcional. String a mostrar en el elemento, nombre del grupo, serie o subserie.
 * @param {boolean} props.esBusqueda - Determina si el elemento a cargar es un elemento de lista perteneciente a una b�squeda
 * @param {boolean} props.esPerfil - Determina si el elemento a cargar es un perfil
 * @param {string} props.modoListado - Par�metro del portal que indica si se muestran las im�genes o solo un listado
 * @param {string} props.codigoOriginal - Opcional. El c�digo original del perfil seleccionada.
 * @param {string} props.codigoReferencia - Opcional. El c�digo referencia del perfil para el cliente .
 * @returns {}
 */
const ElementoGridExtrusion = props => {
  return (
    <div
      key={props.id}
      className={props.className}
      itemProp='itemListElement'
      itemScope
      itemType='https://schema.org/Product'
      data-grupo={props.codigoGrupo}
      data-nombre={props.nombreGrupo}
      data-serie={props.codigoSerie}
      data-nombre_serie={props.nombreSerie}
      data-subserie={props.codigoSubserie}
      data-nombre_subserie={props.nombreSubserie}
      data-perfil={props.codigoPerfil}
      data-codigo_original={props.codigoOriginal}
      data-codigo_referencia={props.codigoReferencia}
      data-nombre_perfil={props.nombrePerfil}
      onClick={props.onClick}
      style={{ padding: props.esPerfil ? '15px' : 'unset' }}>
      <a href='#'>
        <meta
          itemProp='sku'
          content={
            props.codigoPerfil || props.codigoSubserie || props.codigoSerie || props.codigoGrupo
          }
        />
        <div className='tt-product thumbprod-center'>
          {props.esPerfil ? (
            props.modoListado === 'I' ? (
              <ImagenPerfil
                codigo_perfil={props.codigoPerfil}
                tipo='WEB'
              />
            ) : (
              ''
            )
          ) : (
            <img
              src={
                props?.imagen
                  ? 'data:image/png;base64, ' + props.imagen
                  : '/assets/img/placeholder.jpg'
              }
              data-src={
                props?.imagen
                  ? 'data:image/png;base64, ' + props.imagen
                  : '/assets/img/placeholder.jpg'
              }
              alt=''
              data-was-processed='true'
              className='loaded img-busqueda'></img>
          )}
          {props?.esBusqueda ? (
            <span>
              {'Grupo: '}
              <span className='font-weight-bold'>{props.nombreGrupo || props.codigoGrupo}</span>
              {props.codigoSerie ? (
                <>
                  <span>{' / serie: '}</span>
                  <span className='font-weight-bold'>{props.nombreSerie || props.codigoSerie}</span>
                </>
              ) : (
                ''
              )}
              {props.codigoSubserie ? (
                <>
                  <span>{' / subserie: '}</span>
                  <span className='font-weight-bold'>
                    {props.nombreSubserie || props.codigoSubserie}
                  </span>
                </>
              ) : (
                ''
              )}
            </span>
          ) : (
            <>
              <div
                style={{
                  display: props.esPerfil ? 'flex' : 'inline-block',
                  /*alignSelf: props.esPerfil ? 'center' : 'unset',*/
                  justifyContent: props.esPerfil ? 'center' : 'unset',
                  width: '100%',
                  textWrap: 'balance',
                }}>
                {props.codigoReferencia || props.codigoOriginal || props.codigoPerfil}
              </div>
              <div
                style={{
                  display: props.esPerfil ? 'flex' : 'inline-block',
                  /*alignSelf: props.esPerfil ? 'center' : 'unset',*/
                  justifyContent: props.esPerfil ? 'center' : 'unset',
                  width: '100%',
                  textWrap: 'balance',
                }}>
                {props.nombreDisplayed}
              </div>
            </>
          )}
        </div>
      </a>
    </div>
  )
}

export default ElementoGridExtrusion
